import useTranslation from 'hooks/useTranslation'
import React from 'react'
import './style.scss'

interface OptionProps {
  title: string
  desc: string
  label?: string
  icon?: JSX.Element | string
  selected?: boolean
  buttonText?: string
  dashedBorder?: boolean
  actionOnClick?: boolean
  secondaryTheme?: boolean
  secondarySelectionColor?: boolean
  additionalContent?: React.ReactNode
  action?: React.MouseEventHandler<HTMLElement>
}

const Option: React.FC<OptionProps> = ({ title, desc, label, icon = 'payments', selected = false, secondaryTheme = false, secondarySelectionColor = false, action, buttonText = '', additionalContent, dashedBorder, actionOnClick }) => {
  const { t } = useTranslation('basic')

  return (
    <div
      className={`option${selected ? ' --selected' : ''}${secondarySelectionColor ? ' --sec-col' : ''}${dashedBorder ? ' --b-dash' : ''}${secondaryTheme ? ' --sec-theme' : ''}`}
      onClick={(actionOnClick && action) ? action : undefined}>
      <div className='option__top'>
        {label && <div className='option__label'>
          <span>{label}</span>
        </div>}

        <div className='center'>
          <div className='option__icon center'>
            {typeof icon === 'string'
              ? <i className={`icon icon--${icon} s24`} />
              : icon}
          </div>

          <div className='option__title'>
            <div className='--secFont'>{title}</div>
            <div>{desc}</div>
          </div>
        </div>

        {(action && !actionOnClick) && <div
          className='option__button --secFont'
          onClick={action}>{buttonText ? buttonText : t(selected ? 'selected' : 'choose')}</div>}
      </div>
      {additionalContent && <div className='option__bottom'>
        {additionalContent}
      </div>}
    </div>
  )
}

export default Option